var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-out"},[_c('span',{staticClass:"title"},[_vm._v("404")]),_c('span',{staticClass:"content"},[_vm._v("I'm Sorry!!")])])
}]

export { render, staticRenderFns }